module.exports = {
  languages: ['en_US', 'zh_HK'],
  defaultLanguage: 'en_US'
}